import { makeGetApiCall } from "../shared/makeApiCall";

const shipmentsApi = {
  getDetails(shipmentId) {
    return makeGetApiCall(
      `shipments/${encodeURIComponent(shipmentId)}/details`,
    );
  },

  async getPackages(shipmentId, orderItemId, search = "") {
    const packages = [];
    let page = 1;
    let lastPage = 1;

    do {
      const params = new URLSearchParams({
        order_item_id: String(orderItemId),
        per_page: "100",
        page: String(page),
      });
      if (search.trim()) params.set("search", search.trim());

      const result = await makeGetApiCall(
        `shipments/${encodeURIComponent(shipmentId)}/packages?${params.toString()}`,
      );
      if (!result.success) return result;

      packages.push(
        ...(Array.isArray(result.data?.data) ? result.data.data : []),
      );
      lastPage = Math.max(1, Number(result.data?.last_page) || 1);
      page += 1;
    } while (page <= lastPage);

    return { success: true, data: packages };
  },
};

export default shipmentsApi;
